/* Unbroken Vine — gift with purchase.

   The book carries three gifts: the Orthodox prayer bracelet and two e-guides
   (Your First Sunday, Am I Really Saved?). The Prayer Book, and the Prayer Book
   + Rope Set, carry one: the Your Icon Corner e-guide. All three are separate 0.00 listings. That is deliberate: a Buy X
   Get Y discount was tried first and cannot work here, because Shopify applies
   only ONE automatic discount per order, so the existing buy2 / buy3 volume
   discounts suppressed it the moment a shopper ordered more than one copy.
   Priced at zero, the gifts are free at every quantity and depend on nothing.

   Rules this file lives by, learned the hard way:
     - it NEVER touches the book line, only the three gift lines
     - it NEVER reloads the page; an earlier version did, and on the cart page
       that raced the theme's own remove request and made the book impossible
       to delete
     - it gives up after a few passes, so a failing write can never loop
   main.js is minified past the point of being safe to hook, so nothing here
   depends on the theme's cart internals and every failure leaves the cart
   exactly as the shopper left it. */
(function () {
  'use strict';

  /* Each anchor is a paid product that brings its own gifts. A gift shared by
     two anchors (the icon-corner guide comes with both the Prayer Book and the
     Prayer Book + Rope Set) is still only added once. */
  var ANCHORS = [
    { id: 48325500666068, gifts: [                    // The Orthodox Faith Made Clear
      { id: 48600185110740, perBook: true,  max: 0 },   // bracelet: one per copy, no ceiling
      { id: 48600152342740, perBook: false, max: 1 },   // Your First Sunday
      { id: 48666149060820, perBook: false, max: 1 }    // Am I Really Saved?
    ] },
    { id: 48581460885716, gifts: [                    // Orthodox Prayer Book
      { id: 48600152375508, perBook: false, max: 1 }    // Your Icon Corner
    ] },
    { id: 48612737614036, gifts: [                    // Prayer Book and 100 Knot Prayer Rope Set
      { id: 48600152375508, perBook: false, max: 1 }    // Your Icon Corner
    ] }
  ];
  function anchorOf(id) {
    id = Number(id);
    for (var i = 0; i < ANCHORS.length; i++) if (ANCHORS[i].id === id) return ANCHORS[i];
    return null;
  }
  /* every gift id this file manages, whatever anchor it belongs to */
  var GIFT_IDS = [];
  ANCHORS.forEach(function (a) { a.gifts.forEach(function (g) { if (GIFT_IDS.indexOf(g.id) === -1) GIFT_IDS.push(g.id); }); });

  /* Threshold gift. The Mystery Gift (a 0.00 listing, like the others) is in
     the cart while the products in it come to $55 or more, and out of it
     below that. It is measured on the same figure the drawer's progress bar
     reads (the items subtotal, gift lines excluded, before discount codes), so
     the bar and the gift can never disagree. If the threshold moves, change it
     here AND in snippets/cart-drawer.liquid (gift_goal). */
  var THRESHOLD_GIFT = { id: 67615420547284, minCents: 5500 };   // Mystery Gift
  GIFT_IDS.push(THRESHOLD_GIFT.id);

  /* Products subtotal in cents, gift lines left out. When a line is about to
     change, pass its variant and new quantity to price the cart as it WILL be. */
  function productSubtotal(items, overrideId, overrideQty) {
    var cents = 0;
    items.forEach(function (i) {
      if (GIFT_IDS.indexOf(Number(i.variant_id)) !== -1) return;
      var qty = i.quantity;
      if (overrideId && Number(i.variant_id) === Number(overrideId)) qty = overrideQty;
      var unit = i.quantity ? i.final_line_price / i.quantity : 0;
      cents += unit * qty;
    });
    return cents;
  }
  function thresholdWanted(cents) { return cents >= THRESHOLD_GIFT.minCents ? 1 : 0; }

  var busy = false;
  var passes = 0;
  var MAX_PASSES = 6;   // a hard stop: no sequence of events can spin this forever

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); });
  }

  /* max === 0 means "no ceiling": a per-book gift then tracks the book quantity
     exactly, so five copies bring five bracelets. */
  function wanted(bookQty, gift) {
    if (bookQty < 1) return 0;
    if (!gift.perBook) return gift.max;
    return gift.max > 0 ? Math.min(bookQty, gift.max) : bookQty;
  }

  /* qtyOf(anchorId) -> quantity in the cart. Returns giftId -> wanted quantity
     for EVERY managed gift, zero where no anchor asks for it. */
  function wantedAll(qtyOf) {
    var out = {};
    GIFT_IDS.forEach(function (id) { out[id] = 0; });
    ANCHORS.forEach(function (a) {
      var q = qtyOf(a.id) || 0;
      a.gifts.forEach(function (g) {
        var w = wanted(q, g);
        out[g.id] = g.perBook ? out[g.id] + w : Math.max(out[g.id], w);
      });
    });
    return out;
  }

  /* A reconcile runs AFTER the theme has drawn the drawer from its own request,
     so a gift it adds or removes would not show until the next redraw. Fetch
     the drawer's sections and hand them to the drawer's own renderContents.
     Only while the drawer is open: at page load the firstPass reload covers it,
     and renderContents would otherwise pop the drawer open uninvited. */
  function redrawDrawer() {
    try {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.renderContents !== 'function') return;
      if (!drawer.classList.contains('active')) return;
      nativeFetch('/?sections=cart-drawer,cart-icon-bubble', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function (sections) { drawer.renderContents({ sections: sections }); })
        .catch(function () {});
    } catch (e) {}
  }

  function reconcile() {
    if (busy || passes >= MAX_PASSES) return Promise.resolve(false);
    busy = true;
    passes++;
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var have = {};
        cart.items.forEach(function (i) { have[i.variant_id] = (have[i.variant_id] || 0) + i.quantity; });
        var want = wantedAll(function (id) { return have[id]; });
        want[THRESHOLD_GIFT.id] = thresholdWanted(productSubtotal(cart.items));

        var add = [], updates = {};
        GIFT_IDS.forEach(function (id) {
          var w = want[id], got = have[id] || 0;
          if (w === got) return;
          if (got === 0) add.push({ id: id, quantity: w });
          else updates[id] = w;                 // quantity 0 removes the line
        });
        if (!add.length && !Object.keys(updates).length) return false;

        /* Removals go first. If the shopper has just deleted the book, clearing
           the now-unfree bracelet matters more than adding anything. */
        var step = Promise.resolve();
        if (Object.keys(updates).length) step = step.then(function () { return post('/cart/update.js', { updates: updates }); });
        if (add.length) step = step.then(function () { return post('/cart/add.js', { items: add }); });
        return step.then(function () { return true; });
      })
      .catch(function () {
        passes = MAX_PASSES;                    // a failed write must not be retried in a loop
        return false;
      })
      .then(function (changed) {
        busy = false;
        if (changed) {
          try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
          redrawDrawer();
        }
        return changed;
      });
  }

  /* Themes post add-to-cart as JSON, FormData or urlencoded. Read all three.
     Returns the line items AND the section-rendering fields: this theme asks for
     `sections=cart-drawer,cart-icon-bubble` so it can redraw the drawer from the
     response. Dropping them is why an earlier version added the gifts correctly
     server-side while the shopper saw nothing happen at all. */
  function readAdd(body) {
    try {
      if (!body) return null;
      var items = null, sections = null, sectionsUrl = null;

      if (typeof body === 'string') {
        if (body.charAt(0) === '{') {
          var o = JSON.parse(body);
          sections = o.sections || null;
          sectionsUrl = o.sections_url || null;
          if (o.items) {
            items = o.items.map(function (i) {
              return { id: Number(i.id), quantity: Number(i.quantity) || 1 };
            });
          } else if (o.id) {
            items = [{ id: Number(o.id), quantity: Number(o.quantity) || 1 }];
          }
        } else {
          var p = new URLSearchParams(body);
          sections = p.get('sections');
          sectionsUrl = p.get('sections_url');
          if (p.get('id')) items = [{ id: Number(p.get('id')), quantity: Number(p.get('quantity')) || 1 }];
        }
      } else if (typeof FormData !== 'undefined' && body instanceof FormData) {
        sections = body.get('sections');
        sectionsUrl = body.get('sections_url');
        if (body.get('id')) {
          items = [{ id: Number(body.get('id')), quantity: Number(body.get('quantity')) || 1 }];
        }
      }

      if (!items) return null;
      return { items: items, sections: sections, sectionsUrl: sectionsUrl };
    } catch (e) { return null; }
  }

  /* Read a /cart/change.js or /cart/update.js body. Returns {id|line, quantity}
     for a single-line change, or null for anything more complicated. */
  function readChange(body) {
    try {
      if (!body || typeof body !== 'string') return null;
      var sections = null, sectionsUrl = null;
      var o = body.charAt(0) === '{' ? JSON.parse(body) : null;
      if (o) {
        sections = o.sections || null;
        sectionsUrl = o.sections_url || null;
      } else {
        var p = new URLSearchParams(body);
        if (p.get('quantity') === null) return null;
        sections = p.get('sections');
        sectionsUrl = p.get('sections_url');
        o = { id: p.get('id'), line: p.get('line'), quantity: Number(p.get('quantity')) };
      }
      if (o.updates) return null;               // a bulk update is not ours to rewrite
      if (typeof o.quantity === 'undefined') return null;
      return {
        id: o.id,
        line: Number(o.line) || 0,
        quantity: Number(o.quantity),
        sections: sections,
        sectionsUrl: sectionsUrl
      };
    } catch (e) { return null; }
  }

  var nativeFetch = window.fetch;

  window.fetch = function (input, init) {
    var args = arguments;
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var opts = init || {};
    var method = (opts.method || (input && input.method) || 'GET').toUpperCase();

    /* Send the book and its gifts as ONE request, so the theme's cart drawer
       already has the gifts when it renders from the response. */
    if (!busy && method === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
      var parsed = readAdd(opts.body);
      var items = parsed && parsed.items;
      var anchorsIn = items ? items.filter(function (i) { return anchorOf(i.id); }) : [];
      if (anchorsIn.length) {
        /* The cart renders newest line first, so the gifts are sent BEFORE the
           book and in reverse: the book then sits at the top with its three
           gifts tucked underneath, which is what makes the group read as a
           bundle rather than as four separate purchases. */
        var merged = [];
        var addWant = wantedAll(function (id) {
          var hit = anchorsIn.filter(function (i) { return i.id === id; })[0];
          return hit ? hit.quantity : 0;
        });
        GIFT_IDS.slice().reverse().forEach(function (id) {
          if (!addWant[id]) return;
          var already = items.some(function (i) { return i.id === id; });
          if (!already) merged.push({ id: id, quantity: addWant[id] });
        });
        merged = merged.concat(items);

        var payload = { items: merged };
        /* hand back the same sections the theme asked for, or its drawer has
           nothing to render and the click looks like it did nothing */
        if (parsed.sections) payload.sections = parsed.sections;
        if (parsed.sectionsUrl) payload.sections_url = parsed.sectionsUrl;

        var addReq = nativeFetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });
        /* A gift may already have been in the cart (a second anchor added later),
           which /cart/add.js would double. Tidy that up once the theme is done. */
        try { addReq.then(function () { passes = 0; setTimeout(reconcile, 700); }).catch(function () {}); } catch (e) {}
        return addReq;
      }
    }

    /* The shopper changing the BOOK line is the important case. Rewriting it as a
       single /cart/update.js that also corrects the gifts means the theme renders
       the finished cart from its own response: no second request, nothing stale on
       screen, and no reload racing the request the shopper just made. */
    if (!busy && method === 'POST' && /\/cart\/(change|update)(\.js)?(\?|$)/.test(url)) {
      var change = readChange(opts.body);
      if (change) {
        busy = true;
        return nativeFetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var target = change.id;
            if (!target && change.line) {
              var line = cart.items[change.line - 1];
              target = line && line.variant_id;
            }
            if (!anchorOf(target)) throw 'not-an-anchor';

            var have = {};
            cart.items.forEach(function (i) { have[i.variant_id] = (have[i.variant_id] || 0) + i.quantity; });
            have[Number(target)] = change.quantity;

            var updates = {};
            updates[Number(target)] = change.quantity;
            var w = wantedAll(function (id) { return have[id]; });
            w[THRESHOLD_GIFT.id] = thresholdWanted(productSubtotal(cart.items, target, change.quantity));
            GIFT_IDS.forEach(function (id) { updates[id] = w[id]; });

            /* Hand back the SAME sections the drawer asked for. Without them the
               response has nothing for it to re-render from, and Dawn reports
               "There was an error while updating your cart" even though the
               cart itself updated correctly. The add path above already does
               this; the change path did not. */
            var payload = { updates: updates };
            if (change.sections) payload.sections = change.sections;
            if (change.sectionsUrl) payload.sections_url = change.sectionsUrl;

            return nativeFetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(payload)
            });
          })
          .then(function (res) { busy = false; return res; })
          .catch(function () {
            busy = false;                       // anything unexpected: let the original stand
            /* A line that brings no gifts (the necklace, say) still moves the
               subtotal, so once the shopper's own change has landed, re-check
               the threshold gift. Without this, removing a non-gift line left
               the Mystery Gift in a cart that had dropped under $55. */
            var fallback = nativeFetch.apply(null, args);
            try { fallback.then(function () { passes = 0; setTimeout(reconcile, 500); }).catch(function () {}); } catch (e) {}
            return fallback;
          });
      }
    }

    var out = nativeFetch.apply(this, arguments);

    /* Any other cart write can strand a gift behind a removed book. Wait for the
       theme to finish its own re-render before touching anything, so we are
       never racing the request the shopper actually made. */
    if (!busy && method === 'POST' && /\/cart\/(change|update)(\.js)?(\?|$)/.test(url)) {
      try { out.then(function () { passes = 0; setTimeout(reconcile, 500); }).catch(function () {}); } catch (e) {}
    }
    /* A product that brings no gifts of its own (the necklace, the decoration
       set) can still carry the cart over or under $55, so adds are re-checked
       too. The reconcile's own writes run with busy set, so this cannot loop. */
    if (!busy && method === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
      try { out.then(function () { passes = 0; setTimeout(reconcile, 700); }).catch(function () {}); } catch (e) {}
    }
    return out;
  };


  /* ---- "2x" in front of a gift that arrives more than once ----------------
     The count lives in the row's data-quantity attribute. CSS cannot reach it:
     attr() only reads the element the pseudo is attached to, never a parent. So
     the prefix is written into the DOM instead, and re-applied whenever the
     theme redraws the cart, which it does from scratch on every change. */
  var GIFT_HANDLES = ['orthodox-bracelet-free-gift',
                      'your-first-sunday-e-guide',
                      'am-i-really-saved-e-guide',
                      'your-icon-corner-e-guide'];

  function decorate() {
    try {
      GIFT_HANDLES.forEach(function (h) {
        var rows = document.querySelectorAll('.cart-item--product-' + h);
        Array.prototype.forEach.call(rows, function (row) {
          var name = row.querySelector('.cart-item__name');
          if (!name) return;
          /* Shrine put the line quantity on the row as data-quantity; Dawn
             does not, so fall back to the quantity input it always renders.
             Without this the "4x" prefix was silently dead. */
          var qty = parseInt(row.getAttribute('data-quantity') || '', 10);
          if (!qty) {
            var input = row.querySelector('input[name="updates[]"], .quantity__input');
            qty = input ? parseInt(input.value, 10) : 1;
          }
          if (!qty || qty < 1) qty = 1;
          var base = name.getAttribute('data-gwp-title');
          if (base === null) {
            base = name.textContent.trim();
            name.setAttribute('data-gwp-title', base);
          }
          var wanted = qty > 1 ? qty + '\u00d7 ' + base : base;
          if (name.textContent.trim() !== wanted) name.textContent = wanted;
        });
      });
    } catch (e) {}
  }

  /* The drawer replaces its markup wholesale, so a one-off pass would be undone
     by the next redraw. Watch for those redraws and re-apply. */
  function watch() {
    decorate();
    try {
      var mo = new MutationObserver(function () {
        if (watch._t) clearTimeout(watch._t);
        watch._t = setTimeout(decorate, 40);
      });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  /* Safety net for carts built by form posts, XHR, or an earlier session. */
  function flag(v) {
    try { return v === undefined ? sessionStorage.getItem('uv_gwp_reloaded')
                                 : (v === null ? sessionStorage.removeItem('uv_gwp_reloaded')
                                               : sessionStorage.setItem('uv_gwp_reloaded', v)); }
    catch (e) { return null; }
  }

  function firstPass() {
    reconcile().then(function (changed) {
      /* The page-load pass may find a cart left stale by an earlier session and
         correct it, in which case the rendered HTML is already wrong and a reload
         is the honest fix. At page load nothing is in flight, so it cannot race a
         shopper's request. The flag is armed BEFORE reloading and only cleared on
         a load that changed nothing, which is what makes a loop impossible. */
      if (!changed) { flag(null); return; }
      if (flag()) return;
      flag('1');
      window.location.reload();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { firstPass(); watch(); });
  } else {
    firstPass();
    watch();
  }
})();

/* ---- cart drawer upsell: colour picker ----------------------------------
   Picks which variant the row's Add button sends and swaps the thumbnail. */
(function () {
  'use strict';
  document.addEventListener('click', function (event) {
    var opt = event.target.closest('[data-cart-upsell-swatch]');
    if (!opt) return;
    var box = opt.closest('.cart-upsell');
    if (!box) return;
    box.querySelectorAll('[data-cart-upsell-swatch]').forEach(function (o) {
      o.setAttribute('aria-checked', o === opt ? 'true' : 'false');
    });
    var add = box.querySelector('[data-cart-upsell-add]');
    if (add) add.dataset.variantId = opt.dataset.variantId;
    var img = box.querySelector('[data-cart-upsell-image] img');
    if (img && opt.dataset.image) {
      img.removeAttribute('srcset');
      img.src = opt.dataset.image;
    }
  });
})();

/* ---- cart drawer upsell -------------------------------------------------
   Adds the offered product and re-renders the drawer through Dawn's own
   renderContents, which expects the response's `sections` keyed by
   'cart-drawer' and 'cart-icon-bubble'.

   The first version fired the request and then did nothing with the reply: it
   left the button disabled showing an ellipsis for good, and the drawer never
   redrew, so the row that should have disappeared stayed put and a second
   click was ignored because the button was still disabled. */
(function () {
  'use strict';

  function restore(btn, label) {
    btn.disabled = false;
    btn.textContent = label;
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-cart-upsell-add]');
    if (!btn || btn.disabled) return;

    var id = Number(btn.dataset.variantId);
    if (!id) return;

    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = '\u2026';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: id, quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (state) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && state && state.sections) {
          /* renderContents replaces the drawer's markup, so this button is
             gone with it and needs no restoring. */
          drawer.renderContents(state);
          return;
        }
        window.location.reload();
      })
      .catch(function () {
        /* A failed add must hand the control back, or the row is dead. */
        restore(btn, label);
      });
  });
})();

/* ---- loading state on cart writes --------------------------------------
   The drawer re-renders in place, so prices change under the shopper with no
   warning. Mark the drawer busy for the duration of any cart write: the items
   dim, stop taking clicks, and a spinner shows. Driven off fetch rather than
   the theme's internals, so it covers the gift rewrites in this file too.

   A counter, not a boolean: a quantity change fires more than one request and
   the first to finish must not clear a state the others still need. */
(function () {
  'use strict';

  var inFlight = 0;
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  function drawer() { return document.querySelector('cart-drawer'); }

  function begin() {
    inFlight++;
    var d = drawer();
    if (d) d.classList.add('is-cart-updating');
  }

  function end() {
    inFlight = Math.max(0, inFlight - 1);
    if (inFlight > 0) return;
    var d = drawer();
    if (!d) return;
    /* A beat after the response so the redraw lands under the overlay rather
       than the shopper watching it happen. */
    setTimeout(function () {
      if (inFlight === 0) d.classList.remove('is-cart-updating');
    }, 180);
  }

  var wrapped = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    if (method !== 'POST' || !CART_WRITE.test(url)) return wrapped.apply(this, arguments);

    begin();
    var out;
    try {
      out = wrapped.apply(this, arguments);
    } catch (e) {
      end();
      throw e;
    }
    /* end() must run whether the write succeeded or failed, or the drawer
       stays dimmed and unusable. */
    return out.then(
      function (r) { end(); return r; },
      function (e) { end(); throw e; }
    );
  };
})();
